import script from "./allocateOrderBlackDy.vue?vue&type=script&setup=true&lang=ts"
export * from "./allocateOrderBlackDy.vue?vue&type=script&setup=true&lang=ts"

import "./allocateOrderBlackDy.vue?vue&type=style&index=0&id=0d428a54&lang=less&scoped=true"

import exportComponent from "D:\\projectLy\\2025伟本\\weben-les-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d428a54"]])

export default __exports__